/* eslint-disable */
export class DIContainer {
  private static instance: DIContainer;
  private registry: Map<
  string,
  {
    creator: () => any;
    isSingleton: boolean;
    instance?: any;
  }
  > = new Map();

  private constructor() {}

  static getInstance(): DIContainer {
    if (!DIContainer.instance) {
      DIContainer.instance = new DIContainer();
    }
    return DIContainer.instance;
  }

  register<T>(
    identifier: string | Function,
    creator: () => T,
    isSingleton: boolean = true
  ): void {
    const key = typeof identifier === 'function' ? identifier.name : identifier;
    this.registry.set(key, { creator, isSingleton });
  }

  resolve<T>(identifier: string | Function): T {
    const key = typeof identifier === 'function' ? identifier.name : identifier;
    const registration = this.registry.get(key);

    if (!registration) {
      // 提供更详细的错误信息，帮助调试顺序问题
      const availableKeys = Array.from(this.registry.keys());
      throw new Error(
        `No registration found for ${key}. ` +
        `Available registrations: ${availableKeys.join(', ')}. ` +
        'Make sure @Injectable decorators are executed before @Inject decorators.'
      );
    }

    if (registration.isSingleton && registration.instance) {
      return registration.instance;
    }

    const instance = registration.creator();

    if (registration.isSingleton) {
      registration.instance = instance;
    }

    return instance;
  }

  autoResolve<T>(type: new (...args: any[]) => T): T {
    const paramTypes: any[] = Reflect.getMetadata('design:paramtypes', type) || [];
    const injectParams: any[] = Reflect.getMetadata('inject:params', type) || [];
    
    const dependencies = paramTypes.map((paramType, index) => {
      // 如果有指定的注入token，使用它；否则使用参数类型
      const injectToken = injectParams[index] || paramType;
      return this.resolve(injectToken);
    });
    
    const instance = new type(...dependencies);
    
    return instance;
  }

  clear(): void {
    this.registry.clear();
  }
}
